import React from 'react';
import Head from 'next/head';
import Script from 'next/script';
import { FRONTEND_CNET_URL, DEFAULT_COUNTRY_CODE, COOKIEBOT_ID } from '../utils/constants';
import BBHeading from '../components/03_organisms/BodyBlocks/Text/BBHeading';
import CenteredColumn from '../components/04_templates/ContentLayouts/CenteredColumn';
import LandingPageTemplate from '../components/04_templates/PageLayouts/LandingPage';
import '../styles/styles.scss';

/**
 * We integrate cookie bot via GTM, it will inject cookiebot script
 * on this page and show cookies table for users.
 */
const CookiePolicyPage = () => (
  <LandingPageTemplate id="cookie-declaration-page">
    <Head>
      <title>Cookie policy | Concern Worldwide</title>
      <link rel="canonical" href={`${FRONTEND_CNET_URL}/cookie-policy`} />
      <meta
        name="description"
        content={`${
          DEFAULT_COUNTRY_CODE === 'IE' ? 'concern.net' : 'concern.org.uk'
        } uses cookies to help us ensure the best possible digital experience for you, and to help us target our marketing more effectively.`}
      />
    </Head>
    <CenteredColumn>
      <BBHeading title="Cookie policy" Tag="h1" />
      {/**
       * Cookie declaration will be added above an element with CookieDeclaration id.
       * We use the approach with "div + script" instead of the approach from cookiebot docs
       * to avoid any issues with different blockers.
       */}
      <div id="CookieDeclaration" />
      <Script src={`https://consent.cookiebot.com/${COOKIEBOT_ID}/cd.js`} />
    </CenteredColumn>
  </LandingPageTemplate>
);

// Opt-out of Automatic Static Optimization.
// See https://nextjs.org/docs/api-reference/next.config.js/runtime-configuration
CookiePolicyPage.getInitialProps = async () => ({});

export default CookiePolicyPage;
